import { NotificationOptions } from '@/src/components/c-snackbar/CSnackbar';

type NotificationsListener = (options: NotificationOptions) => void;

let listener: NotificationsListener | null = null;

export const notificationsStore = {
  subscribe(fn: NotificationsListener) {
    listener = fn;
  },
  unsubscribe() {
    listener = null;
  },
  show(options: NotificationOptions) {
    if (listener) listener(options);
  },
};
